import { useState } from 'react';
import { ITrainersData, ITrainersTool } from '@/types/trainers';
import ImageCropper from '@/components/ui/trainers/shared/ImageCropper';
import { IPoints } from '@/types/map';
import DisplayMapFeatureCandidateContent from '@/components/ui/trainers/DisplayMapFeatureCandidateContent';
import { DisplayOnMap } from '@/components/ui/trainers/shared/DisplayOnMap';
import Markdown from '@/components/ui/trainers/shared/Markdown';
import ImageCarousel from '@/components/ui/trainers/ImageCarousel';

interface Props {
  data?: ITrainersData;
  tool?: ITrainersTool;
  contentHeight?: number;
}

export default function DefaultTrainerContent({
  data,
  tool,
  contentHeight,
}: Props) {
  const { images = [] } = data?.content || {};
  const hasAppleMaps = !!tool?.args?.hasAppleMaps;
  const SVGOverlay = tool?.args?.svgOverlay;
  const image = images?.[0] || '';
  const detections = data?.content?.detections;
  const { lat, lon, azimuth, positionCandidates } = data?.content || {};
  const currentDetection = detections?.[0];
  const label = data?.content?.elementDescription;
  const [imageHeight, setImageHeight] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  let options = {};
  let points = data?.content?.imagesCoords as IPoints;
  if (points) {
    options = {
      selectedCameraIndex: selectedImageIndex,
      alignViewBasedOnPoints: true,
    };
  }

  if (positionCandidates) {
    points = positionCandidates as IPoints;
    options = {
      hideTargetMarker: true,
      alignViewBasedOnPoints: true,
      selectedCameraIndex: undefined,
    };
  }

  return (
    <>
      <div
        className="relative flex flex-1 flex-col items-center justify-center"
        style={{ height: contentHeight }}>
        {data?.content?.mapFeatureCandidate ? (
          <div>
            <DisplayMapFeatureCandidateContent content={data?.content} />
          </div>
        ) : lat || lon ? (
          <div className="flex w-full">
            <div className="h-full w-1/2">
              <ImageCarousel
                key={data?.content?.leaseId}
                images={images}
                SVGOverlay={SVGOverlay}
                detections={detections}
                onImageLoaded={setImageHeight}
                onSelectedImageChange={setSelectedImageIndex}
                startWithIndex="largestDetection"
              />
            </div>
            {imageHeight ? (
              <div
                className="relative w-1/2"
                style={{
                  height: imageHeight,
                }}>
                <DisplayOnMap
                  target={{ lat, lon, azimuth }}
                  points={points}
                  options={{
                    hasAppleMaps,
                    ...options,
                  }}
                />
              </div>
            ) : null}
          </div>
        ) : detections ? (
          <div className="flex size-full flex-col items-center justify-center">
            {label && <Markdown text={label} />}
            <ImageCropper
              key={image}
              limitWidth={240}
              limitHeight={280}
              imageSrc={image}
              boundingBox={currentDetection || []}
            />
          </div>
        ) : (
          <ImageCarousel
            key={data?.content?.leaseId}
            images={images}
            SVGOverlay={SVGOverlay}
            onImageLoaded={setImageHeight}
          />
        )}
      </div>
    </>
  );
}
